/*
 * @Author: Ashley.Liu
 * @Date: 2022-07-29 17:17:21
 * @LastEditTime: 2022-12-08 18:40:14
 * @Description: add v-md-editor
 */
import './public-path'
import './styles/style.scss'
import './plugins/zoom-ui'
import './permission' // permission control
import router from './router/index'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import Highlight from './utils/highlight'
import VueClipboard from 'vue-clipboard2'
import Base from '@/plugins/base'
import Console from '@/plugins/console'
import less from 'less'
import AntPathMatcher from 'ant-path-matcher'
import { message } from '@/plugins/message'
import DateTimeView from '@/components/base/DateTimeView'
import IconSvg from '@/components/svgIcon/icon-svg'
import Pagination from '@/components/Pagination'

Vue.component('icon-svg', IconSvg)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./icons/svg', false, /\.svg$/)
requireAll(req)

Vue.use(less)
Vue.use(Base)
Vue.use(Console)
Vue.component('date-time-view', DateTimeView)
Vue.component('pagination', Pagination)
Vue.use(ElementUI, { locale })
Vue.use(Highlight)
Vue.use(VueClipboard)
Vue.prototype.$message = message

// const Vue = window.Vue
Vue.config.productionTip = false

const antMatcher = new AntPathMatcher()

Vue.prototype.hasPermission = function (resource, action) {
  const permissions = this.$store.getters.permissions || []
  return permissions.indexOf(resource + '_' + action) !== -1
}
Vue.prototype.hasRole = function (role) {
  const roles = this.$store.getters.roles || []
  return roles.filter(item => antMatcher.match(role, item)).length > 0
}
Vue.prototype.setTime = function (row, column, cellValue, index) {
  let time = row[column.property]
  return new Date(parseInt(time)).toLocaleString()
}

Vue.prototype.hasAnyRole = function (roles) {
  const ownedRoles = this.$store.getters.roles || []
  if (ownedRoles.length === 0) {
    return false
  }
  for (let i = 0; i < roles.length; i++) {
    const hasAccess =
      ownedRoles.filter(item => antMatcher.match(roles[i], item)).length > 0
    if (hasAccess) {
      return true
    }
  }
  return false
}

Vue.prototype.$eventBus = new Vue()

export default new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app')
